import { usePreferredMarketLocalStorage } from './use-preferred-market'

export function usePreferredHomesRoute() {
  const [preferredMarket] = usePreferredMarketLocalStorage();
  const route = preferredMarket !== undefined ? `/homes/${preferredMarket}` : '/homes'

  return route;
}
